
require("./verify-box.less");